import { translate } from "utils";
import { SubscriptionTransaction } from "features/subscription-transaction/type";
import { formatPriceApp } from "utils";
import { selectLang } from "store/lang/langSlice";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { APP_PATH } from "constants/path";

export default function ProductList({
	subScriptionTransaction,
}: {
	subScriptionTransaction: SubscriptionTransaction;
}) {
	const lang = useSelector(selectLang);

	const getVoucherId = () => {
		if (
			subScriptionTransaction?.voucherCode?.voucher &&
			typeof subScriptionTransaction?.voucherCode?.voucher !== "string"
		) {
			return subScriptionTransaction?.voucherCode?.voucher._id;
		}
		return "";
	};

	return (
		<div className="mt-4 bg-white shadow-lg p-4">
			<p className="font-semibold text-lg ">{translate("Product list")}</p>
			<div className="mt-2 overflow-x-auto">
				<table className="min-w-[500px] w-full border">
					<thead>
						<tr className="bg-blue-400 text-white">
							<th className="border-y font-semibold p-2">
								{translate("Product name")}
							</th>
							<th className="border-y font-semibold w-2/12 p-2 text-center">
								{translate("Price")}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className="p-2 border-b text-center">
								<Link
									to={`${APP_PATH.subscriptionClass}/${subScriptionTransaction.merchantSubscription?.subscriptionPackage.id}`}
									className="underline hover:underline"
									target="_blank"
								>
									{
										subScriptionTransaction.merchantSubscription
											?.subscriptionPackage.name[lang]
									}
								</Link>
							</td>
							<td className="p-2 border-b text-center">
								{formatPriceApp(subScriptionTransaction.originalPrice)} USD
							</td>
						</tr>

						{!!subScriptionTransaction.voucherCode && (
							<tr>
								<td className="p-2 border-b text-center">
									<Link
										to={`${APP_PATH.loyaltyVouchersMerchant}/${getVoucherId()}`}
										className="underline hover:underline"
										target="_blank"
									>
										{
											(subScriptionTransaction.voucherCode?.voucher as any)
												.attribute[lang].name
										}
									</Link>
								</td>
								<td className="p-2 border-b text-center">
									{subScriptionTransaction.originalPrice -
										subScriptionTransaction.total}{" "}
									USD
								</td>
							</tr>
						)}

						<tr>
							<td className="p-2 text-right font-semibold" colSpan={10}>
								{`${translate("Total")}: ${formatPriceApp(
									subScriptionTransaction.total,
								)} USD`}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
}
